import React from 'react';
import { 
  calculateTotalMRP,
  calculateTotalDiscount,
  calculateDiscountPercentage,
  calculateSubTotal,
  calculateTotal
} from '../../utils/calculations';

function OrderSummary({ items, additionalCharges }) {
  return (
    <div className="bg-gray-50 rounded-lg p-4 mt-6">
      <div className="space-y-2">
        <div className="flex justify-between">
          <span>Total MRP:</span>
          <span>₹{calculateTotalMRP(items).toFixed(2)}</span>
        </div>
        
        <div className="flex justify-between text-green-600">
          <span>Total Discount:</span>
          <span>-₹{calculateTotalDiscount(items).toFixed(2)} ({calculateDiscountPercentage(items)}%)</span>
        </div>

        <div className="flex justify-between">
          <span>Subtotal:</span>
          <span>₹{calculateSubTotal(items).toFixed(2)}</span>
        </div>
        
        {additionalCharges.map(charge => (
          <div key={charge.id} className="flex justify-between">
            <span>{charge.name}:</span>
            <span>₹{charge.amount}</span>
          </div>
        ))}
        
        <div className="flex justify-between font-bold text-lg border-t pt-2 mt-2 text-gray-800">
          <span>Total Amount:</span>
          <span>₹{calculateTotal(items, additionalCharges)}</span>
        </div>
      </div>
    </div>
  );
}

export default OrderSummary; 